import { StyleSheet } from "react-native";

import type { UiTheme } from "../theme";

// Styles for the create-from-scratch setup stage. Generous targets
// (44pt+ steppers) and a single accent CTA, per the reduced-vision
// constraint — this is a one-shot form, density buys nothing here.
export function makeSetupStyles(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    container: {
      padding: s.s5,
      gap: s.s4,
    },
    title: {
      color: p.ink,
      fontSize: t.sizes.lg,
      fontWeight: "800",
    },
    fieldLabel: {
      color: p.ink3,
      fontSize: t.sizes.xs,
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
    },
    input: {
      minHeight: 48,
      borderWidth: 1,
      borderColor: p.border,
      borderRadius: r.r3,
      paddingHorizontal: s.s4,
      // Android pads a TextInput on its own; the minHeight sets the size.
      paddingVertical: 0,
      color: p.ink,
      fontSize: t.sizes.base,
      backgroundColor: p.surface,
    },
    hint: {
      color: p.ink3,
      fontSize: t.sizes.sm,
      lineHeight: t.sizes.sm * 1.4,
    },
    createBtn: {
      minHeight: 40,
      borderRadius: r.r4,
      backgroundColor: p.brand500,
      alignItems: "center",
      justifyContent: "center",
    },
    createBtnDisabled: { backgroundColor: p.surface2 },
    createBtnText: {
      color: p.inkOnBrand,
      fontSize: t.sizes.base,
      fontWeight: "800",
    },
    createBtnTextDisabled: { color: p.ink3 },
    cancelBtn: {
      minHeight: 44,
      alignItems: "center",
      justifyContent: "center",
    },
    cancelText: {
      color: p.ink3,
      fontSize: t.sizes.sm,
      fontWeight: "600",
    },
  });
}
